import React from "react";
import { StyledTag } from "./Tag.styled";
import { ChipProps as MuiTagProps } from "@mui/material/Chip";
import { Icon } from "../Icon";
import IconButton from "../IconButton/IconButton";

export interface TagProps extends Omit<MuiTagProps, "icon" | "size"> {
  /**
   * The size of the tag, which can be either 'big' or 'small'.
   */
  tagSize?: "big" | "small";
  /**
   * Indicates if the tag has an error state.
   */
  isError?: boolean;
  /**
   * The name of the icon to be displayed.
   */
  icon?: string;
}

export default function Tag({
  tagSize = "small",
  isError = false,
  onDelete,
  icon,
  ...props
}: TagProps) {
  return (
    <StyledTag
      icon={
        tagSize === "big" && icon ? (
          <Icon size="medium" name={icon} />
        ) : undefined
      }
      tagSize={tagSize}
      isError={isError}
      onDelete={onDelete}
      deleteIcon={
        onDelete ? (
          <IconButton
            size={tagSize === "big" ? "medium" : "small"}
            name="close"
            //TODO: Consult with designers what should be the IconButton type here and replace
            type="UNSAFE_transparent"
            title="Delete"
          />
        ) : (
          <></>
        )
      }
      {...(typeof props.label === "string" && { "aria-label": props.label })}
      aria-invalid={isError}
      {...props}
    />
  );
}
